const pluginTranslations = [
    {
        type: "Paragraph",
        options: {
            display: {
                title: 'Paragraphe',
                description: 'Écrivez du texte'
            }
        }
    },
    {
        type: "Accordion",
        options: {
            display: {
                title: 'Menu',
                description: 'Ajoutez un menu déroulant'
            }
        }
    },
    {
        type: "HeadingOne",
        options: {
            display: {
                title: 'Titre 1',
                description: 'Grand titre de section'
            }
        }
    },
    {
        type: "HeadingTwo",
        options: {
            display: {
                title: 'Titre 2',
                description: 'Titre de section moyen'
            }
        }
    },
    {
        type: "HeadingThree",
        options: {
            display: {
                title: 'Titre 3',
                description: 'Petit titre de section'
            }
        }
    },
    {
        type: "Blockquote",
        options: {
            display: {
                title: 'Citation',
                description: 'Ajoutez une citation'
            }
        }
    },
    {
        type: "Callout",
        options: {
            display: {
                title: 'Annotation',
                description: 'Mettez en valeur le texte'
            }
        }
    },
    {
        type: "NumberedList",
        options: {
            display: {
                title: 'Liste ordonnée',
                description: 'Créez une liste avec des nombres'
            }
        }
    },
    {
        type: "BulletedList",
        options: {
            display: {
                title: 'Liste à puces',
                description: 'Créez une liste à puces'
            }
        }
    },
    {
        type: "TodoList",
        options: {
            display: {
                title: 'Liste de tâches',
                description: 'Insérez une liste de tâches'
            }
        }
    },
    {
        type: "Code",
        options: {
            display: {
                title: 'Code',
                description: 'Écrivez votre plus beau code'
            }
        }
    },
    {
        type: "LinkPlugin",
        options: {
            display: {
                title: 'Lien',
                description: 'Créez un lien'
            }
        }
    },
    {
        type: "Embed",
        options: {
            display: {
                title: 'Insérer',
                description: 'Insérez des vidéos, Google Maps et plus'
            }
        }
    },
    {
        type: "Image",
        options: {
            display: {
                title: 'Image',
                description: 'Importez depuis l\'appareil ou un lien'
            }
        }
    },
    {
        type: "Video",
        options: {
            display: {
                title: 'Vidéo',
                description: 'Ajoutez depuis l\'appareil, Youtube, Vimeo'
            }
        }
    },
    {
        type: "File",
        options: {
            display: {
                title: 'Fichier',
                description: 'Partagez vos fichiers PDFs, vidéos, etc'
            }
        }
    }
];

export function translateYooptaPlugins(plugin) {
    const existingDisplay = plugin.options.display;
    const matchingPlugin = pluginTranslations.find((p) => p.type === plugin.type);

    if (matchingPlugin) {
        const translatedDisplay = matchingPlugin.options.display;
        matchingPlugin.options.display = { ...existingDisplay, ...translatedDisplay };
        return matchingPlugin.options
    } else {
        return existingDisplay;
    }
}
